import {
  CButton,
  CFormCheck,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import moment from "moment";
import TableColumnSortIcon from "src/components/Sort/TableColumnSortIcon";

const TripTableData = ({
  isLoading,
  data,
  sortConfig,
  handleClickColumnSort,
  onRowClick = null,
  handleAllSelectCheckBox,
  selectAllStatus,
  userInfo,
  selectedCheckboxes,
  handleCheckBox,
  selectedCountry,
  handleEditTrip,
}) => {
  return (
    <CTable align="middle" className="mb-0 border" hover responsive>
      <CTableHead color="light">
        <CTableRow>
          {userInfo &&
            ["superAdmin", "admin", "cvit"].includes(userInfo.userType) && (
              <CTableHeaderCell className="text-center">
                <CFormCheck
                  id="AllSelectBox"
                  onChange={handleAllSelectCheckBox}
                  checked={selectAllStatus}
                  style={{
                    width: "20px",
                    height: "20px",
                    margin: "0px 10px",
                  }}
                />
              </CTableHeaderCell>
            )}
          <CTableHeaderCell className="text-center">Action</CTableHeaderCell>
          <CTableHeaderCell
            className="text-center"
            onClick={() => handleClickColumnSort("tripId")}
            style={{ cursor: "pointer" }}
          >
            Trip ID
            <TableColumnSortIcon {...{ sortConfig, dataKey: "tripId" }} />
          </CTableHeaderCell>
          <CTableHeaderCell
            className="text-center"
            onClick={() => handleClickColumnSort("tripName")}
            style={{ cursor: "pointer" }}
          >
            Trip Name
            <TableColumnSortIcon {...{ sortConfig, dataKey: "tripName" }} />
          </CTableHeaderCell>
          <CTableHeaderCell className="text-center">Status</CTableHeaderCell>
          <CTableHeaderCell
            className="text-center"
            onClick={() => handleClickColumnSort("createdAt")}
            style={{ cursor: "pointer" }}
          >
            Start Time{" "}
            <TableColumnSortIcon {...{ sortConfig, dataKey: "createdAt" }} />
          </CTableHeaderCell>
          <CTableHeaderCell
            className="text-center"
            onClick={() => handleClickColumnSort("updatedAt")}
            style={{ cursor: "pointer" }}
          >
            End Time{" "}
            <TableColumnSortIcon {...{ sortConfig, dataKey: "updatedAt" }} />
          </CTableHeaderCell>
          <CTableHeaderCell
            className="text-center"
            onClick={() => handleClickColumnSort("orderCount")}
            style={{ cursor: "pointer" }}
          >
            Total Orders{" "}
            <TableColumnSortIcon {...{ sortConfig, dataKey: "orderCount" }} />
          </CTableHeaderCell>
          <CTableHeaderCell className="text-center">
            Order Status
          </CTableHeaderCell>
          <CTableHeaderCell
            className="text-center"
            onClick={() => handleClickColumnSort("tripAssignedBy")}
            style={{ cursor: "pointer" }}
          >
            CVIT Officer{" "}
            <TableColumnSortIcon
              {...{ sortConfig, dataKey: "tripAssignedBy" }}
            />
          </CTableHeaderCell>
          <CTableHeaderCell
            className="text-center"
            onClick={() => handleClickColumnSort("tripAssignedTo")}
            style={{ cursor: "pointer" }}
          >
            Driver{" "}
            <TableColumnSortIcon
              {...{ sortConfig, dataKey: "tripAssignedTo" }}
            />
          </CTableHeaderCell>

          <CTableHeaderCell
            className="text-center"
            onClick={() => handleClickColumnSort("tripRoute")}
            style={{ cursor: "pointer" }}
          >
            Route Name{" "}
            <TableColumnSortIcon {...{ sortConfig, dataKey: "tripRoute" }} />
          </CTableHeaderCell>
          <CTableHeaderCell className="text-center">
            Priority
            <TableColumnSortIcon {...{ sortConfig, dataKey: "tripName" }} />
          </CTableHeaderCell>
          <CTableHeaderCell className="text-center" style={{ width: "10%" }}>
            Remarks
          </CTableHeaderCell>
        </CTableRow>
      </CTableHead>
      <CTableBody>
        {isLoading ? (
          <CTableRow className="text-center">
            <CTableDataCell colSpan="16">Loading...</CTableDataCell>
          </CTableRow>
        ) : data && data.length == 0 ? (
          <CTableRow className="text-center">
            <CTableDataCell colSpan="16">No data available</CTableDataCell>
          </CTableRow>
        ) : (
          data.map((item, index) => (
            <CTableRow
              v-for="item in tableItems"
              key={index}
              onClick={onRowClick ? () => onRowClick(item._id) : undefined}
              style={{ cursor: "pointer" }}
            >
              {userInfo &&
                ["superAdmin", "admin", "cvit"].includes(userInfo.userType) && (
                  <CTableHeaderCell className="text-center">
                    <CFormCheck
                      id={item._id}
                      value={item._id}
                      disabled={
                        item.tripStatus === "completed" ||
                        (userInfo.userType === "superAdmin" &&
                          selectedCountry &&
                          selectedCountry?.value !== item.country)
                      }
                      defaultChecked={
                        selectedCheckboxes &&
                        selectedCheckboxes.includes(item._id)
                      }
                      onClick={handleCheckBox}
                      style={{
                        width: "20px",
                        height: "20px",
                        margin: "0px 10px",
                      }}
                    />
                  </CTableHeaderCell>
                )}
              <CTableDataCell className="text-center">
                <CButton
                  size="sm"
                  color="primary"
                  style={{ color: "white" }}
                  className="text-capitalize"
                  onClick={() => handleEditTrip(item._id)}
                >
                  Edit
                </CButton>
              </CTableDataCell>
              <CTableDataCell className="text-center">
                {item?.tripId}
              </CTableDataCell>
              <CTableDataCell className="text-center">
                {item?.tripName}
              </CTableDataCell>
              <CTableDataCell className="text-center">
                {item.tripStatus === "assigned" && (
                  <CButton
                    size="sm"
                    color="warning"
                    style={{ color: "white" }}
                    className="text-capitalize"
                  >
                    {item?.tripStatus}
                  </CButton>
                )}

                {item.tripStatus === "inProgress" && (
                  <CButton
                    size="sm"
                    color="secondary"
                    style={{ color: "white" }}
                    className="text-capitalize"
                  >
                    In Progress
                  </CButton>
                )}
                {item.tripStatus === "completed" && (
                  <CButton
                    size="sm"
                    color="success"
                    style={{ color: "white" }}
                    className="text-capitalize"
                  >
                    {item?.tripStatus}
                  </CButton>
                )}
              </CTableDataCell>
              <CTableDataCell className="text-center">
                {moment(item.createdAt).format("DD-MM-YYYY h:mm A")}
              </CTableDataCell>
              <CTableDataCell className="text-center">
                {item.tripStatus === "completed" &&
                  moment(item.updatedAt).format("DD-MM-YYYY h:mm A")}
              </CTableDataCell>
              <CTableDataCell className="text-center">
                <CButton
                  type="button"
                  color="link"
                  className="btn btn-sm btn-secondary text-black"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    window.open(
                      `/manage-trip/orders/${item?.tripId}`,
                      "_blank"
                    );
                  }}
                >
                  {item.orderCount}
                </CButton>
              </CTableDataCell>
              <CTableDataCell className="text-center">
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                  <div style={{
                    backgroundColor: '#2eb85c', // success green
                    color: 'white',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    minWidth: '24px',
                    textAlign: 'center'
                  }}>
                    {item.booking_orders?.filter(order => order.status === 'delivered').length || 0}
                  </div>
                  <div style={{
                    backgroundColor: '#f9b115', // warning yellow
                    color: 'white',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    minWidth: '24px',
                    textAlign: 'center'
                  }}>
                    {item.booking_orders?.filter(order => order.status === 'assigned').length || 0}
                  </div>
                  <div style={{
                    backgroundColor: 'purple', // info blue
                    color: 'white',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    minWidth: '24px',
                    textAlign: 'center'
                  }}>
                    {item.booking_orders?.filter(order => order.status === 'driver').length || 0}
                  </div>
                </div>
              </CTableDataCell>
              <CTableDataCell className="text-center">
                <div>
                  {item?.tripAssignedBy?.firstName}{" "}
                  {item?.tripAssignedBy?.lastName}
                </div>
              </CTableDataCell>
              <CTableDataCell className="text-center">
                <div>
                  {`${item?.tripAssignedTo?.firstName}
                  ${item?.tripAssignedTo?.lastName}
                    `
                }
                </div>
              </CTableDataCell>

              <CTableDataCell className="text-center">
                <div>{item?.tripRoute?.name}</div>
              </CTableDataCell>
              <CTableDataCell className={`text-center text-capitalize ${item.priority == "emergency" ? "emergency-color" : ""}`}>
                {item?.priority || 'Normal'}
              </CTableDataCell>

              <CTableDataCell className="text-center text-capitalize">
                {item?.tripRemarks}
              </CTableDataCell>
            </CTableRow>
          ))
        )}
      </CTableBody>
    </CTable>
  );
};

export default TripTableData;
